import React from "react";
import { fetchVerbalResultAnalysis, saveVerbalAiAnalysis } from "../../utils/hearingResultAnalysis";
import { AnalysisModalBase } from "./analysisModalBase";
import type { AnalysisModalModel } from "../../type/analitycs";
import type { VerbalTestResultPayload } from "../../type/verbalTest";

const VerbalAnalysisModal: React.FC<AnalysisModalModel<VerbalTestResultPayload>> = ({
  isOpen,
  onClose,
  parsedResult,
  demographics,
  id,
  cachedAnalysis,
  onAnalysisSaved,
}) => (
  <AnalysisModalBase
    isOpen={isOpen}
    onClose={onClose}
    parsedResult={parsedResult}
    demographics={demographics}
    id={id}
    cachedAnalysis={cachedAnalysis}
    onAnalysisSaved={onAnalysisSaved}
    fetchFn={fetchVerbalResultAnalysis}
    saveFn={saveVerbalAiAnalysis}
  />
);

export default VerbalAnalysisModal;
